import { Box, Circle, IconButton, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

import { ShoppingCartIcon } from '@/imports/ui/chakra/feather/shopping-cart';
import { useCart } from '@/state/cart/useCart';
import { CartItemTypeEnum } from '@/graphql-types/globalTypes';

export const CartNavLinkIconDisplay: React.FC = () => {
  const { itemCount = 0, items = [] } = useCart();
  const router = useRouter();

  // Check if cart has membership items
  const hasMembership = useMemo(() => {
    return items.some(item => item.type === CartItemTypeEnum.MEMBERSHIP);
  }, [items]);

  return (
    <Box position="relative">
      <Link href="/cart" passHref>
        <IconButton
          aria-label="Shopping Cart"
          icon={<ShoppingCartIcon />}
          variant="outline"
          colorScheme="gray"
          isRound
        />
      </Link>
      {itemCount > 0 && (
        <Circle
          position="absolute"
          top={-1}
          right={-1}
          size={4}
          backgroundColor="red.600"
          zIndex={2}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text 
            color="white" 
            fontSize={10} 
            lineHeight="1em"
          >
            {itemCount > 9 ? '9+' : itemCount}
          </Text>
        </Circle>
      )}
      {hasMembership && (
        <Circle
          position="absolute"
          bottom={-1}
          right={-1}
          size={3}
          backgroundColor="purple.500"
          zIndex={2}
          border="1.5px solid white"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text 
            color="white" 
            fontSize={8} 
            lineHeight="1em"
            fontWeight="bold"
          >
            M
          </Text>
        </Circle>
      )}
    </Box>
  );
};
